(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("osjsAuth0AuthAdapter", [], factory);
	else if(typeof exports === 'object')
		exports["osjsAuth0AuthAdapter"] = factory();
	else
		root["osjsAuth0AuthAdapter"] = factory();
})(window, function() {
return 